import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import {convertPipeToBrTag} from "../../utils";

/**
 *  Accordion
 */
class Accordion extends Component {
  static propTypes = {
    pageName: PropTypes.string,
    pcText: PropTypes.string,
    mbText: PropTypes.string,
    open: PropTypes.bool,
    children: PropTypes.node,
    simpleAnimation: PropTypes.bool,
    enabled: PropTypes.bool,
    onClose: PropTypes.func,
    onOpen: PropTypes.func,
    current: PropTypes.bool,
  };
  static defaultProps = {
    pageName: null,
    pcText: null,
    mbText: null,
    open: false,
    children: null,
    simpleAnimation: false,
    enabled: false,
    onClose: null,
    onOpen: null,
    current: false,
  };
  
  constructor(props) {
    super();
    this.props = props;
    this.state = {
      open: this.props.open,
      height: 0,
    };
    this.intervalId = null;
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    if (this.intervalId) clearInterval(this.intervalId);
    this.intervalId = setInterval(()=> {
      this.handleResize();
    }, 500);
    //this.handleResize();
  };
  
  // componentWillReceiveProps(nextProps) {
  //   if (this.state.open !== nextProps.open) {
  //     if (this.state.open === true) {
  //       this.setState({
  //         open: false,
  //         height: 0,
  //       });
  //       if (this.props.onClose !== null) this.props.onClose();
  //     } else {
  //       this.setState({
  //         open: true,
  //         height: this.refs.wrap.clientHeight,
  //       });
  //       if (this.props.onOpen !== null) this.props.onOpen();
  //     }
  //   }
  // };
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    if (this.intervalId) clearInterval(this.intervalId);
  }
  
  open() {
    this.setState({
      open: true,
      height: this.refs.wrap.clientHeight,
    });
    if (this.props.onOpen !== null) this.props.onOpen();
  }
  
  close() {
    this.setState({
      open: false,
      height: 0,
    });
    if (this.props.onClose !== null) this.props.onClose();
  }
  
  onResize() {
    setTimeout(()=> {
      this.handleResize();
    }, 200)
  }
  
  render() {
    return (
      <dl
        className={'Accordion' + ((this.props.enabled === true) ? '--enabled': '') + ((this.state.open === true) ? ' open': '') + ((this.props.simpleAnimation === true) ? ' simpleAnimation': '') + ((this.props.current === true) ? ' current': '')}>
        <dt>
          <a className="Accordion__title"
             href="javascript:void(0);"
             onClick={(e) => {
               this.handleClick(e)
             }}
          >
                        <span className="Accordion__title-pc">
                            <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(this.getPcText())}}/>
                        </span>
            <span className="Accordion__title-mb">
                            <div dangerouslySetInnerHTML={{__html: convertPipeToBrTag(this.getMbText())}}/>
                        </span>
            <span className="Accordion__title-icon"/>
            <span className="Accordion__title-icon2"/>
          </a>
        </dt>
        {(() => {
          if (this.props.simpleAnimation === false) {
            return (
              <dd className="Accordion__contents"
                  style={{height: this.state.height}}
              >
                <div className="Accordion__container"
                     ref="wrap">
                  {(this.props.children !== null) ? this.props.children: null}
                </div>
              </dd>
            )
          } else {
            return (
              <dd className="Accordion__contents">
                <div className="Accordion__container"
                     ref="wrap">
                  {(this.props.children !== null) ? this.props.children: null}
                </div>
              </dd>
            )
          }
        })()}
      </dl>
    )
  }
  
  //
  getPcText = () => {
    if (this.props.pcText !== null) {
      return this.props.pcText;
    }
    return this.props.pageName;
  };
  
  //
  getMbText = () => {
    if (this.props.mbText !== null) {
      return this.props.mbText;
    } else {
      if (this.props.pcText !== null) {
        return this.props.pcText;
      }
    }
    return this.props.pageName;
  };
  
  //
  handleClick = (e) => {
    e.preventDefault();
    if (this.state.open === true) {
      this.setState({
        open: false,
        height: 0,
      });
      if (this.props.onClose !== null) this.props.onClose();
    } else {
      this.setState({
        open: true,
        height: this.refs.wrap.clientHeight,
      });
      if (this.props.onOpen !== null) this.props.onOpen();
    }
  };
  
  //
  handleResize = () => {
    if (this.state.open === false || this.props.simpleAnimation === true) return;
    this.setState({height: this.refs.wrap.clientHeight});
  };
  
}

export default Accordion;



// WEBPACK FOOTER //
// ./src/components/accordion/index.jsx